// IIFE - Immediately Invoked Function Expression
(function($, window, document) {

    // The $ is now locally scoped 

    // Listen for the jQuery ready event on the document
    $(function() {

        // The DOM is ready!

    });

    /*const stickyEl = document.querySelector(".observer-progress");*/
    /*const readingWrap = document.getElementById("observer-progress");
    const observer = new IntersectionObserver( 
      ([e]) => e.target.classList.toggle("is-sticked", e.intersectionRatio < 1),
      { threshold: [1] }
    );*/
    //observer.observe(document.querySelector('main'));
    //observer.observe(readingWrap);

    $('.hover-trg').on('mouseover', function (e) {
      e.preventDefault();
      if ($(window).width() > 769) {
        //$('body').toggleClass("active-form-contact");
        $(this).closest('.hover-trg-wrap').find('.hover-trg').removeClass('-active');
        $('.hover-trg-ref').removeClass('-active');
        $(this).addClass('-active');
        let parent = $(this).attr('data-ref');
        document.getElementById(parent).classList.add('-active');
      }
    });
    $('.hover-trg').on('click', function (e) {
      e.preventDefault();
      if ($(window).width() < 769) {
        //$('body').toggleClass("active-form-contact");
        $(this).closest('.hover-trg-wrap').find('.hover-trg').removeClass('-active');
        $('.hover-trg-ref').removeClass('-active');
        $(this).addClass('-active');
        let parent = $(this).attr('data-ref');
        document.getElementById(parent).classList.add('-active');
      }
    });

    //Offcanvas Form trigger on hash
    $('a[href*="#trg-contactform"]').on('click', function (e) {
      e.preventDefault();
      $('body').toggleClass("active-form-contact");
    });

    //custom dropdown list trigger
    var ddlTrigger = document.getElementsByClassName('_custom-ddl-trigger');
    
    var toggleDropdown = function() {
         console.log('ddl click');
         var elementDdl = this.closest('._custom-ddl');
         elementDdl.classList.toggle("open");
        /*document.body.classList.toggle("menu-active");*/
    };

    for (var i = 0; i < ddlTrigger.length; i++) {
        ddlTrigger[i].addEventListener('click', toggleDropdown, false);
    }

    // Create canvas mask on image
    (function(){

      var imagecanvas = document.createElement('canvas');
      var imagecontext = imagecanvas.getContext('2d');

      /* uncomment do see the canvas to debug
      document.body.appendChild(imagecanvas);
      */
      window.addEventListener('load', function(){
        [].forEach.call(document.querySelectorAll('.mask'), function(img){
          var newImg = document.createElement('img');
          newImg.src = img.src;
          
          newImg.onload = function() {
            var width  = newImg.width;
            var height = newImg.height;

            var mask = document.createElement('img');
            mask.src = img.getAttribute('data-mask');
            mask.onload = function() {
              imagecanvas.width  = width;
              imagecanvas.height = height;

              imagecontext.drawImage(mask, 0, 0, width, height);
              imagecontext.globalCompositeOperation = 'source-in';
              imagecontext.drawImage(img, 0, 0);

              img.src = imagecanvas.toDataURL();
              img.classList.add('loaded-canvas');
              /*console.log(img)*/
            }
          }
        });
      }, false);

    })();    
    $('.search-trigger').click(function (event) {
        event.preventDefault();
        $('body').toggleClass('search-active');
    });
    /*Dropdown mobile*/
    $('.-dropdown-toggle-hover').click(function(){
      event.preventDefault();
      if ($(window).width() < 769) {
        var ddl = $(this).closest('.-dropdown');
        ddl.toggleClass('open');
      }
    });

    /*Accordion*/
    $('[data-accordion]').click(function(e) {
        e.preventDefault();
        var parent = $(this).closest('.-accordion');
        /*var elParent = $(this).closest('.-accordion-item');*/

        //parent.find('.-accordion-item').removeClass('-active');

        if ( $(this).closest('.-accordion-item').hasClass('-active') ) {
            parent.find('.-accordion-item').removeClass('-active');
            $(this).closest('.-accordion-item').removeClass('-active');
        }else{
            parent.find('.-accordion-item').removeClass('-active');
            $(this).closest('.-accordion-item').addClass('-active');
        }
        
    });

    /*desktop Wealth management main slick*/
    var hgWMSlick =  $('#slick-wm-hg'); 

    if (hgWMSlick.length) {
      var playSpeed = (hgWMSlick.attr('data-speed')?hgWMSlick.attr('data-speed'):6000);
      var boolAutoplay = (hgWMSlick.attr('data-autoplay')?hgWMSlick.attr('data-autoplay'):false);
      console.log(playSpeed);
      hgWMSlick.slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: boolAutoplay,
        autoplaySpeed: playSpeed,
        fade: true,
        cssEase: 'linear',
        /*prevArrow:"<a class='slick-prev -sc-highlight-prev'></a>",
        nextArrow:"<a class='slick-next -sc-highlight-next'></a>",*/
        /*responsive: [
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 3,
                dots: true,
                arrows: true,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                dots: true,
                arrows: false,
              }
            }
        ] */

      });
      $(".-sc-highlight-prev").click(function () {
        hgWMSlick.slick("slickPrev");
      });

      $(".-sc-highlight-next").click(function () {
        hgWMSlick.slick("slickNext");
      });

    }    

    /*home main slick*/
    var homeHGSlick =  $('#slick-home-hg'); 

    if (homeHGSlick.length) {
      var playSpeed = (homeHGSlick.attr('data-speed')?Number(homeHGSlick.attr('data-speed')):4000);
      var boolAutoplay = (homeHGSlick.attr('data-autoplay')?true:false);
      var boolArrows = (homeHGSlick.attr('data-arrows')?true:false);
      var boolDots = (homeHGSlick.attr('data-dots')?true:false);
      homeHGSlick.slick({
        dots: boolDots,
        arrows: boolArrows,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: boolAutoplay,
        autoplaySpeed: playSpeed,
        fade: true,
        cssEase: 'linear',
        /*prevArrow:"<a class='slick-prev -sc-highlight-prev'></a>",
        nextArrow:"<a class='slick-next -sc-highlight-next'></a>",*/
        /*responsive: [
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 3,
                dots: true,
                arrows: true,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                dots: true,
                arrows: false,
              }
            }
        ] */

      });
      $(".-sc-highlight-prev").click(function () {
        homeHGSlick.slick("slickPrev");
      });

      $(".-sc-highlight-next").click(function () {
        homeHGSlick.slick("slickNext");
      });

    }

    /*home secondary slick*/
    var homePortfolioSlick =  $('#slick-home-portfolio'); 

    if (homePortfolioSlick.length) {
      homePortfolioSlick.slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        /*fade: true,
        cssEase: 'linear',*/
      });

    }

    /*home solutions slick*/
    var homeSolutionsv2 =  $('#slick-home-solutions'); 

    if (homeSolutionsv2.length) {
      var playSpeed = (homeSolutionsv2.attr('data-speed')?Number(homeSolutionsv2.attr('data-speed')):4000);
      var boolAutoplay = (homeSolutionsv2.attr('data-autoplay')?true:false);
      var boolArrows = (homeSolutionsv2.attr('data-arrows')?true:false);
      var boolDots = (homeSolutionsv2.attr('data-dots')?true:false);

      homeSolutionsv2.slick({
        dots: boolDots,
        arrows: boolArrows,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: boolAutoplay,
        autoplaySpeed: playSpeed,
        /*fade: true,
        cssEase: 'linear',*/
        responsive: [
            /*{
              breakpoint: 769,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: true,
              }
            },*/
            {
              breakpoint: 768,
              settings: 'unslick',
            }
        ]
      });

    }
    $(window).on('resize', function() {
       if( $(window).width() > 420 &&  !homeSolutionsv2.hasClass('slick-initialized')) {
             homeSolutionsv2.slick('reinit');
        }
    });


    /*home secondary half slick*/
    var brandsPageTemplateSlick =  $('#slick-half-brands'); 

    if (brandsPageTemplateSlick.length) {
      brandsPageTemplateSlick.slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        /*fade: true,
        cssEase: 'linear',*/
      });

    }    


    /*segments*/
    var sliderSegments = $('#slick-segments'); 

    if (sliderSegments.length) {
        var playSpeed = (sliderSegments.attr('data-speed')?Number(sliderSegments.attr('data-speed')):4000);
        var boolAutoplay = (sliderSegments.attr('data-autoplay')?true:false);
        var boolArrows = (sliderSegments.attr('data-arrows')?true:false);
        var boolDots = (sliderSegments.attr('data-dots')?true:false);
        var boolInfinite = (sliderSegments.attr('data-infinite')?true:false);
        var currentSlide;
        var slidesCount;
        /*var sliderCounter = document.createElement('div');
        sliderCounter.classList.add('slick-counter');*/

        /*var updateSliderCounter = function(slick, currentIndex) {
            currentSlide = slick.slickCurrentSlide() + 1;
            slidesCount = slick.slideCount;
            $(sliderCounter).text(currentSlide + '/' +slidesCount);
        };

        sliderSegments.on('init', function(event, slick) {
            sliderSegments.append(sliderCounter);
            updateSliderCounter(slick);
        });

        sliderSegments.on('afterChange', function(event, slick, currentSlide) {
            updateSliderCounter(slick, currentSlide);
        }); */

        sliderSegments.slick({
            
            /*centerPadding: '100px',
            slidesToShow: 1,*/
            arrows: boolArrows,
            dots: boolDots,
            autoplay: boolAutoplay,
            autoplaySpeed: playSpeed,
            slidesToShow: 5,
            centerPadding: 0,
            infinite: boolInfinite,
            
            responsive: [
                /*{
                  breakpoint: 2500,
                  settings: {
                    //dots: false,
                    slidesToShow: 5,
                    centerPadding: 0,
                    //infinite: false,
                    //centerMode: false,
                  }
                },*/
                {
                  breakpoint: 769,
                  settings: {
                    /*dots: false,*/

                    slidesToShow: 3,
                    centerPadding: 0,
                    infinite: boolInfinite,
                    centerMode: false,

                  }
                },
                {
                  breakpoint: 431,
                  settings: {
                    /*dots: false,*/
                    arrows: false,
                    dots: true,
                    slidesToShow: 1,
                    infinite: true,
                    centerMode: true,
                    centerPadding: '100px',
                  }
                }
            ]
            /*adaptiveHeight: true,*/
            /*autoplay: true,
            autoplaySpeed: 6000,*/
            /*cssEase: 'linear',*/
            /*easing: 'swing',*/
            /*speed: 500,
            fade: true,
            cssEase: 'linear', 
            dots: true,
            arrows: true,*/
            /*prevArrow:"<a class='slick-prev slick-hg-prev'></a>",
            nextArrow:"<a class='slick-next slick-hg-next'></a>",*/
            /* */
      });

    }

    /*why v2*/
    var whySlickV2 =  $('#slick-why-v2'); 

    if (whySlickV2.length) {
      whySlickV2.slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 6000,
        responsive: [
            {
              breakpoint: 2500,
              settings: 'unslick'
            },
            {
              breakpoint: 769,
              settings: {
                /*dots: false,*/
                slidesToShow: 3,
                autoplay: true,
                /*slidesToShow: 3,
                centerPadding: 0,
                infinite: false,
                centerMode: false,*/

              }
            },
            {
              breakpoint: 431,
              settings: {
                /*dots: false,*/
                slidesToShow: 1,
                autoplay: true,
              }
            }
        ]

      });
    }     

    /*why*/
    var whySlick =  $('#slick-why'); 

    if (whySlick.length) {
      whySlick.slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 6000,
        responsive: [
            {
              breakpoint: 2500,
              settings: {
                /*dots: false,*/
                slidesToShow: 4,
                variableWidth: true,
                /*centerMode: true,*/
                infinite: false,
                /*
                centerMode: false,*/
              }
            },
            {
              breakpoint: 769,
              settings: {
                /*dots: false,*/
                slidesToShow: 3,
                /*slidesToShow: 3,
                centerPadding: 0,
                infinite: false,
                centerMode: false,*/

              }
            },
            {
              breakpoint: 431,
              settings: {
                /*dots: false,*/
                slidesToShow: 1,
              }
            }
        ]
        /*prevArrow:"<a class='slick-prev slick-hg-prev'></a>",
        nextArrow:"<a class='slick-next slick-hg-next'></a>",*/
        /*responsive: [
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 3,
                dots: true,
                arrows: true,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                dots: true,
                arrows: false,
              }
            }
        ] */

      });
      whySlick.addClass('first-slide-is-active');
      whySlick.on('afterChange', function (event, slick, currentSlide) {
      if (currentSlide === 0) {
        /*console.log('First element');*/
        whySlick.addClass('first-slide-is-active');
      } else {
        whySlick.removeClass('first-slide-is-active');
      }
    });
    } 

    /*simple*/
    var simpleSlick =  $('#slick-simple'); 

    if (simpleSlick.length) {
      var playSpeed = (simpleSlick.attr('data-speed')?Number(simpleSlick.attr('data-speed')):4000);
      var boolAutoplay = (simpleSlick.attr('data-autoplay')?true:false);
      var boolArrows = (simpleSlick.attr('data-arrows')?true:false);
      var boolDots = (simpleSlick.attr('data-dots')?true:false);
      var boolInfinite = (simpleSlick.attr('data-infinite')?true:false);

      simpleSlick.slick({
        dots: boolDots,
        arrows: boolArrows,
        infinite: boolInfinite,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: boolAutoplay,
        autoplaySpeed: playSpeed,
        responsive: [
            /*{
              breakpoint: 2500,
              settings: {
                //dots: false,
                slidesToShow: 3,
                infinite: false,
              }
            },*/
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 3,
                arrows: false,
                dots: true,
              }
            },
            {
              breakpoint: 431,
              settings: {
                slidesToShow: 1,
                arrows: false,
                dots: true,
                infinite: true,
              }
            }
        ],

      });

    }     

    /*cases*/
    var casesSlick =  $('#slick-cases'); 

    if (casesSlick.length) {
      casesSlick.slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
            {
              breakpoint: 2500,
              settings: {
                slidesToShow: 5,
                infinite: true,
              }
            },
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 3,
                infinite: false,
              }
            },
            {
              breakpoint: 431,
              settings: {
                infinite: true,
                slidesToShow: 3,
              }
            }
        ]
        /*prevArrow:"<a class='slick-prev slick-hg-prev'></a>",
        nextArrow:"<a class='slick-next slick-hg-next'></a>",*/
        /* */

      });

    }  

    /*portfolio*/
    var portfolioSlick =  $('#slick-portfolio'); 

    if (portfolioSlick.length) {
      portfolioSlick.slick({
        /*dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 6000,*/

        dots: true,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 6000,
        /*centerMode: false,
        variableWidth: true,*/
        /*prevArrow:"<a class='slick-prev slick-hg-prev'></a>",
        nextArrow:"<a class='slick-next slick-hg-next'></a>",*/
        /*responsive: [
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 3,
                dots: true,
                arrows: true,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                dots: true,
                arrows: false,
              }
            }
        ] */

      });

    } 

    /*portfolio fixed 2 itens*/
    var portfolioFixedSlick =  $('#slick-portfolio-2'); 

    if (portfolioFixedSlick.length) {
      portfolioFixedSlick.slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        /*prevArrow:"<a class='slick-prev slick-hg-prev'></a>",
        nextArrow:"<a class='slick-next slick-hg-next'></a>",*/
        responsive: [
            /*{
              breakpoint: 1920,
              settings: {
                slidesToShow: 3,
              }
            },*/
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 5,
                dots: true,
              }
            },
            {
              breakpoint: 460,
              settings: {
                slidesToShow: 2,
                dots: true,
              }
            }
        ]

      });

    }                


    /*titles*/
    var titlesSlick =  $('#slick-titles'); 

    if (titlesSlick.length) {
      titlesSlick.slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        cssEase: 'linear',

        /*prevArrow:"<a class='slick-prev slick-hg-prev'></a>",
        nextArrow:"<a class='slick-next slick-hg-next'></a>",*/
        /*responsive: [
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 3,
                dots: true,
                arrows: true,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                dots: true,
                arrows: false,
              }
            }
        ] */

      });

    }

    /*basic slider*/
    var basicSlick =  $('#slick-basic'); 

    if (basicSlick.length) {
      basicSlick.slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        cssEase: 'linear',
      });

    }

    /*simple*/
    var prizesSlick =  $('#slick-prizes'); 

    if (prizesSlick.length) {
      var playSpeed = (prizesSlick.attr('data-speed')?Number(prizesSlick.attr('data-speed')):4000);
      var boolAutoplay = (prizesSlick.attr('data-autoplay')?true:false);
      var boolArrows = (prizesSlick.attr('data-arrows')?true:false);
      var boolDots = (prizesSlick.attr('data-dots')?true:false);
      var boolInfinite = (prizesSlick.attr('data-infinite')?true:false);

      prizesSlick.slick({
        dots: boolDots,
        arrows: boolArrows,
        infinite: boolInfinite,
        speed: 300,
        slidesToShow: 3.5,
        slidesToScroll: 1,
        autoplay: boolAutoplay,
        autoplaySpeed: playSpeed,
        responsive: [
            /*{
              breakpoint: 2500,
              settings: {
                //dots: false,
                slidesToShow: 3,
                infinite: false,
              }
            },*/
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 3,
                arrows: false,
                dots: true,
              }
            },
            {
              breakpoint: 431,
              settings: {
                slidesToShow: 1,
                arrows: false,
                dots: true,
                infinite: true,
              }
            }
        ],

      });

    }     

    /*slick multiple new products slider*/
    var slickNPMultiple = $('.-np-slick');
    if (slickNPMultiple.length) {
      slickNPMultiple.each(function() {
        $(this).slick({
          infinite: false,
          fade: false,
          dots: true,
          arrows: false,
          infinite: true,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 6000,
          /*prevArrow:'<button type="button" class="slick-prev -highlight-prev"><span class="iconify" data-icon="bi:chevron-left"></span></button>',
          nextArrow:'<button type="button" class="slick-next -highlight-next"><span class="iconify" data-icon="bi:chevron-right"></span></button>',*/
          /*responsive: [
              {
                breakpoint: 769,
                settings: {
                  slidesToShow: 3,
                  dots: true,
                  arrows: true,
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  dots: true,
                  arrows: false,
                }
              }
          ] */

        });   
      }); 
    }    

    var stickySb = document.querySelector('.sticky');
    if (stickySb) {
      if ($(window).width() > 440) {
        var sidebar = new StickySidebar('.sticky', {
          topSpacing: 125,
          bottomSpacing: 0,
          containerSelector: '.sticky-wrap',
          innerWrapperSelector: '.sticky-wrap__inner'
        });
      }
    }

    //Offcanvas Form trigger
    var formTrigger = document.getElementsByClassName("form-trigger-btn"),
        offcanvasForm = document.getElementById("main-menu");
    
    var toggleCanvasForm = function() {
        /*offcanvasForm.classList.toggle("main-menu-active");*/
        document.body.classList.toggle("active-form-contact");
    };

    for (var i = 0; i < formTrigger.length; i++) {
        formTrigger[i].addEventListener('click', toggleCanvasForm, false);
    }

    //form float trigger
    var formFloatTrigger = document.getElementsByClassName("formfloat-trigger-btn");
    
    var toggleFloatForm = function() {
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("floatform-active");
    };

    for (var i = 0; i < formFloatTrigger.length; i++) {
        formFloatTrigger[i].addEventListener('click', toggleFloatForm, false);
    }


    //Menu trigger
    var menuTrigger = document.getElementsByClassName("menu-trigger-btn"),
        menu = document.getElementById("main-nav");
    
    var toggleMenu = function() {
    	   console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("menu-active");
    };

    for (var i = 0; i < menuTrigger.length; i++) {
        menuTrigger[i].addEventListener('click', toggleMenu, false);
    }

    //languages trigger
    var languagesTrigger = document.getElementsByClassName("trigger-lang");
    
    var toggleLanguages = function() {
        //menu.classList.toggle("offcanvas-nav-active");
        this.nextElementSibling.classList.toggle("-hidden");
    };

    for (var i = 0; i < languagesTrigger.length; i++) {
        languagesTrigger[i].addEventListener('click', toggleLanguages, false);
    }

 
    /*Custom select*/
    $('.custom-select').each(function(){
        var $this = $(this), 
        numberOfOptions = $(this).children('option').length;
      
        $this.addClass('select-hidden'); 
        $this.wrap('<div class="select"></div>');
        $this.after('<div class="select-styled"></div>');

        var $styledSelect = $this.next('div.select-styled');
        $styledSelect.text($this.children('option').eq(0).text());
      
        var $list = $('<ul />', {
            'class': 'select-options'
        }).insertAfter($styledSelect);
      
        for (var i = 0; i < numberOfOptions; i++) {
            $('<li />', {
                text: $this.children('option').eq(i).text(),
                rel: $this.children('option').eq(i).val()
            }).appendTo($list);
        }
      
        var $listItems = $list.children('li');
      
        $styledSelect.click(function(e) {
            e.stopPropagation();
            $('div.select-styled.active').not(this).each(function(){
                $(this).removeClass('active').next('ul.select-options').hide();
            });
            $(this).toggleClass('active').next('ul.select-options').toggle();
        });
      
        $listItems.click(function(e) {
            e.stopPropagation();
            $styledSelect.text($(this).text()).removeClass('active');
            $this.val($(this).attr('rel'));
            $list.hide();
            /*console.log($this.val());*/
            var redirectType = $this[0].classList.contains('redirect-select');
            if (redirectType) {
              //console.log('have to redirect');
              redirect($this.val());

            }else{
              //console.log('not redirect');
            }
        });
      
        $(document).click(function() {
            $styledSelect.removeClass('active');
            $list.hide();
        });

    });

    function redirect(goto){
        /*var conf = confirm("Are you sure you want to go elswhere?");
        if (conf && goto != '') {
            window.location = goto;
        }*/
        window.location = goto;
    }
   
    /*Anchor scroll*/
    const anchors = document.querySelectorAll(".scroll-anchor");
     
    for (const anchor of anchors) {
      anchor.addEventListener("click", clickHandler);
    }
     
    function clickHandler(e) {
      e.preventDefault();
      const header = document.querySelector("header").offsetHeight;
      const href = this.getAttribute("href");
      const offsetTop = document.querySelector(href).offsetTop;
     
      scroll({
        top: offsetTop-header,
        behavior: "smooth"
      });
    }


    /*Quick search*/
    var inputQuicksearch = document.querySelector('#quicksearch');
    var items = document.querySelectorAll('.isofilter-item');

    if (inputQuicksearch) {
      inputQuicksearch.addEventListener('keyup', function(ev) {
        var text = ev.target.value;
        var pat = new RegExp(text, 'i');
        for (var i=0; i < items.length; i++) {
          var item = items[i];
          if (pat.test(item.innerText)) {
            item.classList.remove("hidden");
          }
          else {
            item.classList.add("hidden");
          }
        }
      });
    }    



    const MainSearchPreload = document.querySelectorAll(".quicksearch-field");
    var qsItems = document.querySelectorAll('.preload-item');
    var reloadList = document.querySelector('.-search-preload');
    var helperText = document.querySelector('.-search-txt-helper');
    const resultsWrap = document.getElementById('results-list');

    if (reloadList) { //console.log('has');
      var totalItems = qsItems.length;
      let timeout = null;
        for (const inputQuicksearch of MainSearchPreload) {
            inputQuicksearch.addEventListener('keyup', function(ev) {
              clearTimeout(timeout);

              var text = ev.target.value;
              if (text) {
                timeout = setTimeout(function () {
                    searchApi(inputQuicksearch.value);
                }, 1000);
              }else{
                console.log('empty');
                resultsWrap.innerHTML = "";
                reloadList.classList.add('hidden')
              }
            });
        }

        function clearQuickSearch(elements, classRemove){
          for (var i=0; i < elements.length; i++) {
              var el = elements[i];
              el.classList.remove(classRemove);
          }
        }  
    }

    function searchApi(searchTerm) { console.log('searching for '+searchTerm)
      const headingCount = document.getElementById('results-list-count');
      resultsWrap.innerHTML = "";
      headingCount.innerHTML = "Buscando por: "+searchTerm;
      reloadList.classList.remove('hidden');
      var postdata = {
            'search' : searchTerm,
            'action': 'search_rest'
        }   
      $.ajax({
        type: 'POST',
        url: ajax_script.xhr_url,
        dataType: 'json',
        data: postdata,
        success: function(response) {
          //console.log(response);
          
          /*var result = JSON.parse(response);*/
          var resultCount = response.total;
          var resultItems = response.items;

          /*console.log(resultCount);*/
          if (resultCount > 0) {
              headingCount.innerHTML = resultCount+' resultado(s) para: '+searchTerm;
              for (i = 0; i < resultItems.length; i++) {
                var resultID = resultItems[i].id;
                var resultTitle = resultItems[i].title;
                var resultLink = resultItems[i].url;
                addResult(resultTitle, resultLink);
              }
              
          }else{
            headingCount.innerHTML = 'Nenhum resultado encontrado';

          }

        },
        error: function(err) {
          console.error(err);
        }
      })
    }


    function addResult(resultTitle, ResultLink){        
        var li = document.createElement('li');
        var permalink = document.createElement('a');
        var title = document.createElement('span');
        //var address = document.createElement('i');
        var btn = document.createElement('span');

        li.className = "preload-item visibility-fill";
        permalink.href = ResultLink;
        permalink.target = '_blank';
        title.className = "name";
        title.innerHTML = resultTitle;
        btn.className = "-cta";
        btn.innerHTML = "Ver mais";

        permalink.appendChild(title);
        permalink.appendChild(btn);
        li.appendChild(permalink);

        resultsWrap.appendChild(li);
    } 

}(window.jQuery, window, document));